<div class="flex items-center gap-0.5">
  <label class="col-span-2 flex flex-col gap-2 text-sm" [for]="control" hlmLabel>
    <div class="flex items-center gap-0.5">
      <hlm-checkbox
        [class]="{
          'mr-2 rounded-lg border p-[1px]': true,
          'border-destructive': displayErrors(),
          'border-primary': !displayErrors(),
        }"
        [formControlName]="control"
        [disabled]="disabled"
        [id]="control"/>

      @if (label && !labelClick) {
        <span class="text-gray600 cursor-pointer text-sm">{{ label }}</span>
      }
    </div>
  </label>

  @if (label && labelClick) {
    <span class="cursor-pointer text-sm hover:text-primary hover:underline"
          (click)="onLabelClick($event)">{{ label }}</span>
  }
</div>

@if (displayErrors()) {
  @for (error of formControl.errors | keyvalue; track error.key) {
    <div class="mt-1 text-xs text-destructive">
      {{ errorMessages[error.key] }}
    </div>
  }
}
